
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/history",
      function () {
        return require("private-next-pages/company/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/history"])
      });
    }
  